import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { popupAjaxError } from "discourse/lib/ajax-error";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";
import MembersCount from "./members-count.gjs";
import MembersSelector from "./members-selector.gjs";

export default class AddMembers extends Component {
  @service chatApi;
  @service router;
  @service toasts;
  @service siteSettings;
  @service loadingSlider;

  get membersCount() {
    const userCount = this.args.members?.reduce((acc, member) => {
      if (member.type === "group") {
        return acc + member.model.chat_enabled_user_count;
      } else {
        return acc + 1;
      }
    }, 0);
    return userCount + (this.args.channel?.membershipsCount ?? 0);
  }

  get maxMembers() {
    return this.siteSettings.chat_max_direct_message_users;
  }

  @action
  async saveGroupMembers() {
    try {
      this.loadingSlider.transitionStarted();

      const usernames = this.args.members
        .filter((member) => member.type === "user")
        .map((member) => member.model.username);

      const groups = this.args.members
        .filter((member) => member.type === "group")
        .map((member) => member.model.name);

      await this.chatApi.addMembersToChannel(this.args.channel.id, {
        usernames,
        groups,
      });

      this.toasts.success({ data: { message: i18n("saved") } });
      this.router.transitionTo(
        "chat.channel",
        ...this.args.channel.routeModels
      );
    } catch (error) {
      popupAjaxError(error);
    } finally {
      this.loadingSlider.transitionEnded();
    }
  }

  <template>
    <div class="chat-message-creator__add-members-container">
      <div class="chat-message-creator__add-members">
        <MembersCount @count={{this.membersCount}} @max={{this.maxMembers}} />

        <MembersSelector
          @cancel={{@cancel}}
          @channel={{@channel}}
          @close={{@close}}
          @maxReached={{gte this.membersCount this.maxMembers}}
          @members={{@members}}
          @membersCount={{this.membersCount}}
          @onChange={{@onChangeMembers}}
        />

        {{#if @members.length}}
          <div class="chat-message-creator__add-members-footer-container">
            <div class="chat-message-creator__add-members-footer">
              <DButton class="btn-flat" @action={{@cancel}} @label="cancel" />

              <DButton
                class="btn-primary add-to-channel"
                @action={{this.saveGroupMembers}}
                @label="chat.direct_message_creator.add_to_channel"
              />
            </div>
          </div>
        {{/if}}
      </div>
    </div>
  </template>
}
